import { CommonRouteConstants } from "@common/route/common-route.constants";
import { OrganisationPageRouteBuilder } from "@org-common/lib/route/organisation-page-route-builder";
import { PersonalDashboardPageComponent } from "./personal-dashboard-page.component";

export const personalDashboardPageRoute = new OrganisationPageRouteBuilder()
    .usingNgComponent("adapt-personal-dashboard-page", PersonalDashboardPageComponent)
    .atOrganisationUrl(CommonRouteConstants.ActivityDashboard)
    .redirectToThisRouteFromOrganisationUrl(CommonRouteConstants.PersonalDashboard)
    .withTitle("Activities")
    .reloadOnSearch(false)
    .build();
